<!-- <usimweb-status-bar
  *ngIf="isProgress"
  style="top: 0px !important; height: 20px"
  [progress]="progress"
></usimweb-status-bar>

<div class="viewer-background">
  <app-progress-card #progressCard *ngIf="isTask" class="progress-card"></app-progress-card>

  <div *ngIf="!isCompare">
    <div
      [ngClass]="{
        'setup-visible': isSetup == true,
        'setup-hidden': isSetup == false
      }"
      class="cards"
    >
       <app-info-card [project]="project"></app-info-card>
      <app-setup-card
        [isMappingAvailable]="sourceTokenId && targetTokenId"
        [mappingProjectId]="projectId"
        (partsChanged)="partsChanged($event)"
        #setup></app-setup-card> 
    </div>

     <app-ceetron-viewer *ngIf="token" [modelId]="token" class="viewer-full"></app-ceetron-viewer> 
  </div>

  <div *ngIf="isCompare">
     <app-compare-card class="compare"></app-compare-card> 
  </div>

  <app-tool-bar
    [modelId]="token"
    (addModelEmit)="openAddCadDialog()"
    (selectModelEmit)="openCadDialog()"
    (downloadEmit)="downloadFile()"
    (toggleViewEmit)="toggleView($event)"
    (toggleSetupEmit)="isSetup = $any($event)"
    (toggleCompareEmit)="isCompare = $any($event)"
    class="toolbar"></app-tool-bar>
</div> -->

<ceetron-viewer [modelId]="'0'" #viewer></ceetron-viewer>
<div *ngIf="animationBarOpen">
  <app-animation-toolbar class="animation-toolbar"></app-animation-toolbar>
  <app-main-toolbar
    (cuttingPlaneToggle)="toggleCuttingPlane()"
    (isosurfaceToggle)="toggleIsosurface()"
    (isovolumeToggle)="toggleIsovolume()"
    (particleTraceToggle)="toggleParticleTrace()"
    (resultsToggle)="toggleResults()"
    class="main-toolbar"
  ></app-main-toolbar>
  <app-results-config class="feature-editor"></app-results-config>

  <app-cutting-plane-editor class="feature-editor"></app-cutting-plane-editor>
  <app-iso-editor [type]="IsoType.Isosurface" class="feature-editor" #isosurfaceEditor></app-iso-editor>
  <app-iso-editor [type]="IsoType.Isovolume" class="feature-editor" #isovolumeEditor></app-iso-editor>
  <app-particle-trace-editor class="feature-editor"></app-particle-trace-editor>
  <app-scalar-settings-editor class="feature-editor"></app-scalar-settings-editor>
  <app-animation-editor class="feature-editor"></app-animation-editor>
</div>

<!-- <app-main-toolbar
[vertical]="true"
(cuttingPlaneToggle)="toggleCuttingPlane()"
(isosurfaceToggle)="toggleIsosurface()"
(isovolumeToggle)="toggleIsovolume()"
(particleTraceToggle)="toggleParticleTrace()"

(animationToggle)="toggleAnimation()">
</app-main-toolbar> -->
